import { render, staticRenderFns } from "./CryptoWatchList.vue?vue&type=template&id=e7e5ce1c&scoped=true&"
import script from "./CryptoWatchList.vue?vue&type=script&lang=js&"
export * from "./CryptoWatchList.vue?vue&type=script&lang=js&"
import style0 from "./CryptoWatchList.vue?vue&type=style&index=0&id=e7e5ce1c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7e5ce1c",
  null
  
)

export default component.exports